let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("wl2zH")).then(() => parcelRequire('1xWR7'));